<style scoped="scoped" lang="scss">
.hideFormItem {
  //display: none !important;
}

.container {
  //padding-left: 24px;
  //padding-right: 24px;
  //overflow: auto;
  //min-width: 500px;

  // 隐藏表单项
  //.hideFormItem {
  //  display: none !important;
  //}
}
</style>
<style>
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #419fff;
  background-color: #FFFFFF;
  border-color: #419fff;
  /*-webkit-box-shadow: -1px 0 0 0 #419fff;*/
  box-shadow: -1px 0 0 0 #419fff;
}
</style>
<template>
  <div class="prod-container">
    <div style="display: flex;flex-wrap: nowrap;align-items: center;">
      <div>
        <el-radio-group size="mini" v-model="tabPosition">
          <el-radio-button @click="tabChange" :label="1">{{$t('anbanci')}}</el-radio-button>
          <el-radio-button @click="tabChange" :label="2">{{$t('anchanpin')}}</el-radio-button>
          <el-radio-button width="68" @click="tabChange" :label="3">{{$t('mingxi')}}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div v-if="tabPosition==1">
      <shift  v-bind="$attrs" key="444"></shift>
    </div>
    <div v-if="tabPosition==2">
      <product v-bind="$attrs" key="555"></product>
    </div>
    <div v-if="tabPosition==3">
      <statistics_detail v-bind="$attrs" key="111"></statistics_detail>
    </div>
  </div>
</template>
<script type="text/javascript">
import shift from '@@/pages/web/report/equipment_capacity_statistics/production_statistics/shift'
import product from "@@/pages/web/report/equipment_capacity_statistics/production_statistics/product";
import statistics_detail from "@@/pages/web/report/equipment_capacity_statistics/production_statistics/statistics_detail";

export default {
  name: 'web_report_equipment_capacity_statistics_production_statistics_index',
  components: {
    shift,
    product,
    statistics_detail
  },
  data() {
    return {
      tabPosition: 1,
    }
  },
  methods: {
    tabChange(e) {
      let tabid = e.target.dataset.id
      this.tabPosition = tabid
      console.log('1111ddtabChange',this.tabPosition)
    }
  }
}
</script>
